import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {PAGE_STATE} from '../utils.js'

export const UnsubscribeEmailsHeader = ({pageState, userData}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const urlStaticImages = config.get('URL_STATICS_IMAGES')

  const {SUCCESS} = PAGE_STATE

  const pageTitle =
    pageState === SUCCESS
      ? i18n.t('UNSUBSCRIBE_EMAILS_PAGE.SUCCESS_CONTENT.TITLE')
      : i18n.t('UNSUBSCRIBE_EMAILS_PAGE.TITLE')

  const imageSrc =
    pageState === SUCCESS
      ? `${urlStaticImages}illustrations/message-sent.svg`
      : `${urlStaticImages}illustrations/come-back-soon.svg`

  const siteLogo = `${urlStaticImages}logo-coches.svg`

  const isMobile = config.get('isMobile')
  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }
  const isTabletOrWider = useMediaQuery(useMediaQueryBreakpoints.md, initialMediaQueryMatch)

  return (
    <>
      <div className="mt-UserUnsubscribeEmails-siteLogo">
        <AtomImage src={siteLogo} alt={i18n.t('AD_SMARTBANNER_COCHES_TITLE')} />
      </div>
      <div className="mt-UserUnsubscribeEmails-image">
        <AtomImage src={imageSrc} alt={pageTitle} />
      </div>
      <span className="mt-UserUnsubscribeEmails-pretitle">{userData.email}</span>
      <div className="mt-UserUnsubscribeEmails-title">
        <TitleBasic
          as={titleBasicTags.h2}
          size={isTabletOrWider ? titleBasicSizes.l : titleBasicSizes.s}
          title={pageTitle}
        />
      </div>
    </>
  )
}

UnsubscribeEmailsHeader.displayName = 'UnsubscribeEmailsHeader'
UnsubscribeEmailsHeader.propTypes = {
  pageState: PropTypes.string,
  userData: PropTypes.object
}
